import { Col, Row } from 'reactstrap';
import classNames from 'classnames';

const DetailInfoRow = ({ label, value, hidden = false, children }) => {
    return (
        <>
            <Row
                className={classNames('border-bottom text-light text-16 p-3', {
                    'd-none': hidden,
                })}>
                <Col lg="4" className="text-right d-none d-lg-block font-weight-bold">
                    {label}
                </Col>
                <Col md="12" sm="12" xs="12" className="d-lg-none">
                    {label}
                </Col>
                <Col lg="8" md="12" sm="12" xs="12">
                    {children ? (
                        <>{children}</>
                    ) : (
                        <>
                            <span className="d-lg-none">&emsp;</span>
                            {value || '--'}
                        </>
                    )}
                </Col>
            </Row>
        </>
    );
};

export default DetailInfoRow;